import { useState, useEffect, useRef } from 'react';
import texture from "./layers/texture";

export default function TissueSVG(props) {
    const [filter, setFilter] = useState(null)
    const [dimensions, setDimensions] = useState(null);
    const [logoSize, setLogoSize] = useState(null)
    const imageRef = useRef(null);


    useEffect(() => {
        const image1 = new Image();
        image1.src = props.t1Logo;
    
        const image2 = new Image();
        image2.src = props.t2Logo;
    
        const dimensionsArray = [];
        let loadedImagesCount = 0;
    
        const handleImageLoad = (width, height) => {
            dimensionsArray.push({ width, height });
            loadedImagesCount++;
    
            if (loadedImagesCount === 2) {
                setDimensions(dimensionsArray);
            }
        };
    
        image1.onload = function() {
            handleImageLoad(this.width, this.height);
        };
    
        image2.onload = function() {
            handleImageLoad(this.width, this.height);
        };
    
        return () => {
            image1.onload = null;
            image2.onload = null;
        };
    }, [props.t1Logo, props.t2Logo]);
    

    useEffect(() => {
        console.log({dimensions})
        const maximumSize = 5
        function percentageIncrease(num_1, num_2, larger = "width") {
            var size1 = maximumSize;
            var size2;
            var increase = ((num_1 - num_2) / num_2) * 100;
            size2 = size1 + ((5 / 100) * increase)
            return (larger == "width") ? { width: size2, height: size1 } : { width: size1, height: size2 };
        }
        if (dimensions != null) {
            var logoSizes = []
            dimensions.forEach(element => {
                const { width, height } = element
                if (width > height) logoSizes.push(percentageIncrease(width, height, "width"))
                else if (height > width) logoSizes.push(percentageIncrease(height, width, "height"))
                else logoSizes.push({ width: maximumSize, height: maximumSize })
            });
            console.log({logoSizes})
            setLogoSize(logoSizes)
        }
    }, [dimensions])


    function RenderLogos({ logo, width, height, xAxis, yAxis, row, column, xmargin, ymargin }) {
        var lastAxis = { x: xAxis, y: yAxis }
        var collector = []
        for (var r = row; r > 0; r--) {
            lastAxis.y = (r == row) ? yAxis : lastAxis.y + ymargin + height;
            for (var c = column; c > 0; c--) {
                lastAxis.x = (c == column) ? xAxis : lastAxis.x + xmargin + width;
                collector.push(<image id="LOGO" xlinkHref={logo} width={width+"%"} height={height+"%"} x={`${lastAxis.x}%`} y={`${lastAxis.y}%`} style={{rotate:"-25deg"}}/>)
            }
        }
        return (<>{collector}</>)
    }

    return (
        logoSize &&
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" className="svgProduct hover-magnify">
            <title>{JSON.stringify(logoSize)}</title>
            <defs>
                <image width="70%" id="texture" href={"data:image/png;base64," + texture} />
                <image id="tilogo1" href={props.t1Logo} />
                <image id="tilogo2" href={props.t2Logo} style={{rotate:"-25deg"}} />
                <clipPath id="tissue1">
                    <rect x="10%" y="18%" width="70%" height="53.3%" />
                </clipPath>
                <clipPath id="tissue2">
                    <rect x="20%" y="28%" width="70%" height="53.3%" />
                </clipPath>
            </defs>
            <style>
            </style>
            <g clip-path="url(#tissue1)">
                <rect x="0%" y="0%" width="100%" height="100%" style={{ fill: props.t1Color }} />
                <RenderLogos logo={props.t1Logo} width={logoSize?.[0]?.width} height={logoSize?.[0]?.height} xAxis={-20} yAxis={5} row={12} column={12} xmargin={3} ymargin={3} />
                <use id="TISSUE_TEXTURE" href="#texture" x="10%" y="18%" />
            </g>

            <g clip-path="url(#tissue2)">
                <rect x="0%" y="0%" width="100%" height="100%" style={{ fill: props.t2Color }} />
                <RenderLogos logo={props.t2Logo} width={logoSize?.[1]?.width} height={logoSize?.[1]?.height} xAxis={-15} yAxis={26} row={11} column={15} xmargin={2} ymargin={3} />
                <use id="TISSUE_TEXTURE" href="#texture" x="20%" y="28%" />
            </g>
        </svg>
    )
}